var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTecnologia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5 20.276C94.5 18.612 93.838 17.014 92.662 15.838C91.486 14.662 89.888 14 88.224 14C76.702 14 52.298 14 40.776 14C39.112 14 37.514 14.662 36.338 15.838C35.162 17.014 34.5 18.612 34.5 20.276C34.5 38.246 34.5 89.754 34.5 107.724C34.5 109.388 35.162 110.986 36.338 112.162C37.514 113.338 39.112 114 40.776 114C52.298 114 76.702 114 88.224 114C89.888 114 91.486 113.338 92.662 112.162C93.838 110.986 94.5 109.388 94.5 107.724C94.5 89.754 94.5 38.246 94.5 20.276Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 100H94.5",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22H71",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.5 54C80.5 50.686 77.814 48 74.5 48C68.782 48 60.218 48 54.5 48C51.186 48 48.5 50.686 48.5 54C48.5 58.04 48.5 63.456 48.5 68.102C48.5 74.008 51.964 79.364 57.35 81.784C61.048 83.448 64.5 85 64.5 85C64.5 85 67.952 83.448 71.65 81.784C77.036 79.364 80.5 74.008 80.5 68.102V54Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58 65.496L63 69.496L71 62.496",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTecnologia);
export default __webpack_public_path__ + "static/media/tecnologia.cf5255e10445347817f4130edd58541e.svg";
export { ForwardRef as ReactComponent };